import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { emit } from './redux/modules/emit';
import { isFramed } from './redux/modules/isFramed';

const { loadend } = emit.actions;
const { checkIsFramed } = isFramed.actions;

class IFrameWrapper extends Component {
  /* eslint-disable */
  static defaultProps = {
    checkIsFramed: null,
    children: null,
    eventStream: [],
    isFramed: false,
    isValidFrame: true,
    loadComplete: null,
  };

  static propTypes = {
    checkIsFramed: PropTypes.func,
    children: PropTypes.node,
    eventStream: PropTypes.array,
    isFramed: PropTypes.bool,
    isValidFrame: PropTypes.bool,
    loadComplete: PropTypes.func
  };
  constructor(props) {
    super(props);
    this.props.checkIsFramed();
    this.props.loadComplete({});
  }
  render() {
    const { isValidFrame, isFramed, children } = this.props;
    if (isFramed) {
      return !isValidFrame ? <React.Fragment>Not valid IFrame</React.Fragment> : <div className="isFramed">{children}</div>;
    }
    return children;
  }
}
const mapStateToProps = state => ({
  isFramed: state.isFramed.isFramed,
  eventStream: state.emit.eventStream,
});

const mapDispatchToProps = dispatch => ({
  checkIsFramed: () => {
    dispatch(checkIsFramed());
  },
  loadComplete: (payload) => {
    dispatch(loadend(payload));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IFrameWrapper);
